import {
  DECLINE_REASON_LABELS,
  QUOTE_STATUS_LABELS,
  type QuoteStatus,
  type QuoteSummary,
  formatIsoDate,
} from '@deizi/shared';

/** Badge class per status (boards Orcamentos-Lista / Orcamentos-Celular). */
export const STATUS_BADGE: Record<QuoteStatus, string> = {
  draft: 'badge',
  sent: 'badge info',
  accepted: 'badge ok',
  declined: 'badge err',
  expired: 'badge warn',
  converted: 'badge solid',
};

export const statusLabel = (s: QuoteStatus) => QUOTE_STATUS_LABELS[s];

/** Statuses still waiting for a decision. */
export const isOpen = (s: QuoteStatus) => s === 'draft' || s === 'sent';

/** "em 7 dias", "expira amanhã", "expira hoje", "venceu 01/10", or "—" once decided. */
export function validityLabel(q: Pick<QuoteSummary, 'status' | 'validUntil' | 'daysUntilExpiry'>): {
  text: string;
  warn: boolean;
} {
  if (q.status === 'expired')
    return { text: `venceu ${formatIsoDate(q.validUntil).slice(0, 5)}`, warn: false };
  if (!isOpen(q.status)) return { text: '—', warn: false };
  const d = q.daysUntilExpiry;
  if (d < 0) return { text: `venceu ${formatIsoDate(q.validUntil).slice(0, 5)}`, warn: true };
  if (d === 0) return { text: 'expira hoje', warn: true };
  if (d === 1) return { text: 'expira amanhã', warn: true };
  return { text: `em ${d} dias`, warn: false };
}

export function declineLabel(
  q: Pick<QuoteSummary, 'declineReason' | 'declineNote'>,
): string | null {
  if (!q.declineReason) return null;
  const reason = DECLINE_REASON_LABELS[q.declineReason];
  return q.declineNote ? `${reason} · “${q.declineNote}”` : reason;
}
